import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from '../src/components/AuthContext';
import { ComicProvider, useComic } from '../src/components/ComicContext';
import PageInfoForm from '../src/components/PageInfoForm';
import ImageHotspotEditor from '../src/components/ImageHotspotEditor';
import ComicListView from '../src/components/ComicListView';
import Login from '../src/components/Login';

// Main app content (protected)
const AppContent = () => {
  const { currentComicId, loadFromLocalStorage, loadComic, clearCurrentComic } = useComic();
  const [view, setView] = useState('list'); // 'list', 'form', 'editor'

  useEffect(() => {
    // Load comics from localStorage on mount
    loadFromLocalStorage();
  }, [loadFromLocalStorage]);

  const handleSelectComic = (comicId) => {
    loadComic(comicId);
    setView('editor');
  };

  const handleCreateNew = () => {
    // Clear any current comic selection when creating new
    clearCurrentComic();
    setView('form');
  };

  const handleFormComplete = () => {
    setView('editor');
  };

  const handleBackToList = () => {
    // Clear current comic when going back to list
    clearCurrentComic();
    setView('list');
  };

  return (
    <>
      {view === 'list' && (
        <ComicListView 
          onSelectComic={handleSelectComic}
          onCreateNew={handleCreateNew}
        />
      )}
      {view === 'form' && (
        <PageInfoForm 
          onComplete={handleFormComplete}
          onCancel={handleBackToList}
        />
      )}
      {view === 'editor' && currentComicId && (
        <ImageHotspotEditor onBack={handleBackToList} />
      )}
    </>
  );
};

// App wrapper that handles authentication
const AppWrapper = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        fontFamily: 'Quicksand, sans-serif'
      }}>
        <div>Carregando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <ComicProvider>
      <AppContent />
    </ComicProvider>
  );
};

// Main App component with providers
export default function App() {
  return (
    <AuthProvider>
      <AppWrapper />
    </AuthProvider>
  );
}
